

import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'

export class FileLinkProps {
  name = 'name'
  url = 'url'
}

@Component({
  components: { }
})
export default class HonjoFileLink extends Vue {
  @Prop(Array) dataSource!: any[]

  @Prop({ default: () => new FileLinkProps() }) props!: FileLinkProps

  @Prop(Function) downloadFn!: () => Promise<any>

  downloading = false

  get rows () {
    return (this.dataSource || []).map((v: any) => {
      return {
        name: v[this.props.name],
        url: v[this.props.url]
      }
    })
  }

  onDownload () {
    if (this.downloadFn) {
      this.downloading = true
      const ret = this.downloadFn()
      if (ret instanceof Promise) {
        ret.finally(() => {
          this.downloading = false
        })
      } else {
        this.downloading = false
      }
    }
  }
}
